import { AUTH_API_URL, fmhNpiAPI } from 'api/APIBase';

export interface FmhToken {
    access_token: string;
    permissions: string[];
    restricted_access: boolean;
    analytics_access: boolean;
    role_name: string;
    npi: string;
    segment_ids: string[];
}

/** Gets FMH token using Auth0 access token */
export async function getFmhToken({
    accessToken,
    payerId = undefined,
}: {
    accessToken: string;
    payerId?: string | null;
}) {
    const url = `${AUTH_API_URL}/access_tokens/for_npi`;
    return fmhNpiAPI({ url })
        .auth(`Bearer ${accessToken}`)
        .query(payerId ? { npi: payerId } : {})
        .get()
        .json<FmhToken>();
}

/** Gets if current user has accepted the terms of use */
export async function getHasAcceptedTermsOfUse() {
    const url = `${AUTH_API_URL}/terms_of_use`;
    return fmhNpiAPI({ url }).get().json<{ accepted: boolean }>();
}

/** Accept current terms of use for the current user */
export async function postAcceptTermsOfUse() {
    const url = `${AUTH_API_URL}/terms_of_use`;
    return fmhNpiAPI({ url }).post().json();
}
